// Protected project stubs (client-safe metadata only)
// Full content lives in protected-content.ts (server-only)
// API route merges content after password validation
import type { Project } from "./projects";
import { COMPANIES } from "./companies";

// Protected projects - only public metadata, NO case study content
// This file IS bundled into client code - keep it minimal
export const protectedProjects: Project[] = [
  {
    id: "vpr",
    order: 0,
    title: "Video Player Redesign",
    subtitle: "A player frozen for years with 15M subscribers waiting",
    company: "Crunchyroll",
    companyLogo: "/images/logo-crunchyroll.png",
    timeline: "2024–Present",
    isProtected: true,
    passwordHint: "Press play",
    prodReady: true,
    ctaIcon: "/images/icon/VPR-Icon.webp",
    brandColor: "#FF5E00",
    brandColorEnd: "#FFB300",
    companies: [COMPANIES.crunchyroll],
    tags: ["Feature Design", "UX/UI", "Cross-Platform", "Living Room", "Mobile", "Web"],
    metrics: [
      { value: "15M+", label: "Subscribers" },
      { value: "8 Platforms", label: "LRX + Web + Mobile" },
      { value: "~1%", label: "Playback Failure" },
      { value: "5x", label: "Below Benchmark" },
    ],
    // All case study content (heroDescription, challenge, solution, process, etc.)
    // lives in protected-content.ts and is only served after password validation
  },
  // ─── IDS/CSC case study — prototype-primary, pw-gated ─────────────────────
  // The showcase is the real research instrument at ids-concept-dev.vercel.app
  // (linked out; it refuses framing). The narrative wraps around it. Narrative slots are TODO(V) in protected-content.ts;
  // raw material in .claude/seeds/ids-riff-canvas.md.
  {
    id: "csc",
    // Sort rule: left/first = recent (V 2026-08-06). csc (2026) is the newest
    // work, so it sorts ahead of vpr (order 0) without renumbering the rest.
    order: -1,
    title: "Making Subtitles Work for Everyone",
    subtitle:
      "Crunchyroll’s first in-player subtitle & captions customization, designed with Deaf and low vision fans",
    company: "Crunchyroll",
    companyLogo: "/images/logo-crunchyroll.png",
    companyUrl: "https://www.crunchyroll.com",
    timeline: "Nov 2025–Present",
    isProtected: true,
    // No embedded /exp route: the showcase is the external instrument
    // (ids-concept-dev.vercel.app). n4/n5 were thinking prototypes (V 2026-09-27).
    // Riddle follows the vpr pattern ("Press play" → saisei): the literal
    // action, answered in Japanese. pw = "jimaku" (字幕, subtitles).
    passwordHint: "Turn them on",
    // Flip to true when the narrative is riffed and real — keeps the study (and
    // its orb, which follows publicProjects) out of prod until then.
    prodReady: true,
    ctaIcon: "/images/icon/CSC-Icon.webp",
    brandColor: "#0EA5E9", // Sky blue
    brandColorEnd: "#22D3EE", // Cyan
    companies: [COMPANIES.crunchyroll],
    tags: ["Accessibility", "UX Research", "Co-Design", "Timed Text", "Inclusive Design", "Prototyping"],
    // Stat row. Every value is sourced (Research Synthesis 2026-05-19, cohort
    // reference v2.1, instrument executive report v0.7.8D). These are scope
    // facts, not outcome metrics — ship numbers arrive with the compliance
    // release (EAA date re-anchored to end of 2026).
    metrics: [
      { value: "5 Pillars", label: "Roadmap Framework" },
      { value: "19", label: "Workshop Participants" },
      { value: "11", label: "Research Participants" },
      { value: "6 Tasks", label: "Built Research Instrument" },
    ],
  },
];
